const Runtime = require('../../engine/runtime');
const StageLayering = require('../../engine/stage-layering');

const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const Clone = require('../../util/clone');
const Cast = require('../../util/cast');
const formatMessage = require('format-message');
const Video = require('../../io/video');

const VideoMotion = require('./library');

const clm = require('clmtrackr/build/clmtrackr');
const pModel = require('./model_pca_20_svm');
const faceDeformer = require('./face_deformer');

// const clm = require('clmtrackr/build/clmtrackr');
// const clm = require('clmtrackr').default;
// import clm from 'clmtrackr';

/**
 * Icon svg to be displayed in the blocks category menu, encoded as a data URI.
 * @type {string}
 */
// eslint-disable-next-line max-len
const menuIconURI = 'data:image/svg+xml;base64,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';

/**
 * Icon svg to be displayed at the left edge of each extension block, encoded as a data URI.
 * @type {string}
 */
// eslint-disable-next-line max-len
const blockIconURI = 'data:image/svg+xml;base64,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';

/**
 * Sensor attribute video sensor block should report.
 * @readonly
 * @enum {string}
 */
const SensingAttribute = {
    /** The amount of motion. */
    MOTION: 'motion',

    /** The direction of the motion. */
    DIRECTION: 'direction'
};

/**
 * Subject video sensor block should report for.
 * @readonly
 * @enum {string}
 */
const SensingSubject = {
    /** The sensor traits of the whole stage. */
    STAGE: 'Stage',

    /** The senosr traits of the area overlapped by this sprite. */
    SPRITE: 'this sprite'
};

/**
 * States the video sensing activity can be set to.
 * @readonly
 * @enum {string}
 */
const VideoState = {
    /** Video turned off. */
    OFF: 'off',

    /** Video turned on with default y axis mirroring. */
    ON: 'on',

    /** Video turned on without default y axis mirroring. */
    ON_FLIPPED: 'on-flipped'
};

/**
 * Class for the motion-related blocks in Scratch 3.0
 * @param {Runtime} runtime - the runtime instantiating this block package.
 * @constructor
 */

const createImg = (src) => {
    let el = document.createElement('img')
    el.src = src
    return el
}
class Scratch3VideoSensingBlocks {
    constructor (runtime) {
        /**
         * The runtime instantiating this block package.
         * @type {Runtime}
         */
        this.runtime = runtime;

        /**
         * The motion detection algoritm used to power the motion amount and
         * direction values.
         * @type {VideoMotion}
         */
        this.detect = new VideoMotion();

        /**
         * The last millisecond epoch timestamp that the video stream was
         * analyzed.
         * @type {number}
         */
        this._lastUpdate = null;

        /**
         * A flag to determine if this extension has been installed in a project.
         * It is set to false the first time getInfo is run.
         * @type {boolean}
         */
        this.firstInstall = true;

        if (this.runtime.ioDevices) {
            // Configure the video device with values from globally stored locations.
            this.runtime.on(Runtime.PROJECT_LOADED, this.updateVideoDisplay.bind(this));

            // Clear target motion state values when the project starts.
            this.runtime.on(Runtime.PROJECT_RUN_START, this.reset.bind(this));

            // Kick off looping the analysis logic.
            this._loop();
            
        }

        this.renderer = this.runtime.renderer;
        this.renderer_canvas = this.renderer.canvas;

        // this.clmtrackr = clmtrackr
        this.tracker_state = 'off';
        this.faceDetectState = 'off';
        this._canvas = document.createElement('canvas');
        this._wgl = document.createElement('canvas');
        this._wglcanvas = document.createElement('canvas');
        // 脸部识别
        this.ctracker = new clm.tracker({
            faceDetection: {
                useWebWorkers: false
            },
        });
        this.ctracker.init(pModel);
        this.ReqId;
        this._skinId
        this._drawable
        // 面具
        // pModel
        // faceDeformer
        this.fd = new faceDeformer();
        this.fd.init(this._wgl);
        this.ReqId2;
        this._skinId2
        this._drawable2
        this.lastModified = Date.now()
            
        // this.video
        // ctracker.start(this.video);
 
        this.currentMask = 'ironman';
        this.masks = {
            monalisa: {
                el: createImg('/static/videosensor/joconde.jpg'),
                data: [[266.539778613571,254.84378898872825],[266.3039097561577,285.302233189556],[271.19357329466345,316.3538789507933],[278.7139543521674,345.15573844972926],[293.15712497356776,368.9809024015706],[312.64193974141324,389.09850232246515],[322.13343587641253,398.3663601209212],[336.9858985066435,401.49456958745145],[356.87519225850986,398.5376499254816],[382.97232156668036,391.79752653535775],[421.61286401088506,373.50434543677886],[448.74322775690695,344.0259953810623],[464.77440099078314,310.71915538180275],[468.2775933241595,272.2241198406615],[466.74514645738424,247.20492682906303],[415.26964981149064,225.8370550250565],[390.13712322351404,222],[361.92175039938184,220.2582273389706],[342.2734356138508,232.04834635926073],[267.7624903928149,236.00873885152805],[280.88607721372824,229],[303.9033677258633,228],[316.6965360192193,234.20369314639848],[281.57998031880885,254.77971856631495],[298.953459306752,246.21641370334032],[315.75345517431316,254.4516165242651],[296.6631361379687,258.36486568494297],[301.63327656416925,252.0239926097512],[398.27491865673994,249.8954346966754],[380.22403819342355,243.83584281695727],[357.98660716766716,253.53119540181672],[378.25469629277825,255.99515336941278],[382.6139465907322,249.6433274231842],[328,253],[314.73794539936216,301.757722929817],[309.85213116736014,314.6797549304112],[313.1507370768973,321.4994076914073],[325.20473159190635,327.87953636258146],[350.1231795924951,324.5425216268138],[358.3783946629097,316.6717252774034],[352.7986254362873,299.5519517987678],[326,282],[314.75674487301336,318.32005216616164],[343.0322275619273,319.2819917007706],[307.87514392633693,346.0346979532304],[316.68926117981914,342.91320569661593],[321.7320399187087,341.45780089974846],[327.8558316510405,343.56649844038935],[336.18423231506125,341.74737597014604],[351.00603891713007,342.2560527375472],[367.88222498993025,344.3660717427479],[357.305053617142,354.4583428810625],[343.5761668856892,358.8848818975423],[328.82001419900075,359.1051832365163],[320.36190636746045,358.71759346010083],[312.61714975606304,353.5625007817836],[318.4988566294063,348.1744254793423],[328.6406599928464,349.73460503451736],[350.2480353796336,349.6831133201238],[349.5754234743516,349.5362145583936],[329.32557946752445,349.67345155068153],[318.2253756678819,347.9222277142419],[324.4964277572599,315.63122813643895],[288.26630901657126,248.99890899333045],[309.3536455351319,248.83485523505226],[307.7075352919804,256.40978560947974],[288.62032608071166,258.5736833679789],[390.2498028902113,244.8663932568382],[368.1047796233772,247.18427292360775],[368.62079313091925,255.76448975973483],[390.7655312307384,254.4464699123733]]
            },
            ironman: {
                el: createImg('/static/videosensor/ironman.jpg'),
                data: [[54.132994582809886,330.2447406482356],[53.94983737338171,411.6786947731232],[59.50117090734213,485.54290769879117],[69.05631570910228,577.6685769791815],[80.73400747239302,669.2047081882876],[156.52267192878207,721.5706883991684],[224.03761978834723,739.1269072358452],[301.4803537679236,738.2366874355024],[373.4196207112528,736.6185556997145],[445.4373067968218,720.1452812831552],[517.3056114476371,670.5474614197833],[531.7799053755264,574.1779931382804],[540.681172219442,487.967223266098],[542.4032150608897,399.64595333584305],[541.5099369565868,318.2177239885218],[484.00763535360403,311.3318445452918],[436.57616449858205,326.12885038303966],[386.214847801106,333.2043197182652],[344.39911403378784,336.7706741289662],[115.84864343665006,313.35525243241443],[152.60840318917894,322.7145050535586],[201.39783835228144,332.29526724516336],[249.58724826191298,336.53976562323317],[116.48023640991207,348.8633768136441],[167.9642886955806,350.9962302246727],[231.6749647028165,359.48349174177827],[168.11831577303042,375.4865728177492],[170.07462103025938,361.76575290725043],[480.7831200700384,348.57719399476593],[423.78106882269736,353.08381522791285],[369.5853199174605,360.3348770905004],[429.2517105029677,374.978498189726],[428.4672557696136,361.0310278167258],[298,363],[253.70821429640165,456.1515630753871],[232.81854206254127,493.52915431030885],[250.27449264190767,519.2760705851281],[294.9905749783811,522.6580485667231],[340.00710866420684,520.8077271147647],[357.28424845402884,493.1349774295837],[336.03221275387335,457.7253897416814],[296,407],[270.69780042635847,507.2277260957476],[320.8265507066314,506.90809731554305],[219.49207600124322,603.6108989555861],[236.4148918469843,589.8509195222699],[267.0123175575189,590.2653879517876],[302.37639394449644,589.4456339021824],[337.18338067155105,591.0755705685021],[366.9537080661368,591.1696362146871],[383.17030058050824,601.5027761622135],[366.07822563380967,614.8268645173376],[336.20759244137867,615.427540755917],[304.12597029775543,615.4777558918809],[270.01910167830954,615.9331065732697],[240.4271869365151,614.9063722445486],[255.5183417994636,603.9175341052295],[302.81892822034536,605.4895650711086],[350.74058301633727,604.2225054756758],[350.6655959742464,603.528118265738],[303.78446463916174,604.3090513544694],[256.409865954666,603.8790201634539],[298.25175247557996,482.7822436696597],[141.22182216936852,346.4270057321846],[206.31948949078424,356.7387529836485],[202.39427275621864,368.9872676086593],[136.2964448024117,368.67555898584044],[454.78000220898934,348.3276075895992],[398.6821272555564,355.2080431875895],[398.9194910642594,369.6579535284187],[466.01878775359233,368.7792910743897]]
            },
            monkeyking: {
                el: createImg('/static/videosensor/monkeyking.png'),
                data: [[145.67131913021615,176.05617006363937],[143.74221538025483,199.93748310110672],[147.8530773243441,223.87508029353128],[155.0731886836996,249.2706469691675],[166.83500384688128,269.45747354057045],[181.90247258710139,285.40550202442563],[198.53406090153877,298.5434433116542],[217.7629016843365,302.98402218912145],[236.59139441592,298.5268613149879],[252.59774925512897,285.68811371235313],[266.9902689021653,270.03173467152993],[278.385143089169,249.98733755289098],[285.25450304965267,224.11106742073588],[289.2086119486869,199.95829690276992],[286.78469078594543,175.8490587777796],[268.15293833921623,174.76499399592896],[256.28273480618356,169.10819755556707],[241.2740579561134,171.25137123285418],[231.01768263925834,178.26092525905622],[163.5669542165009,175.30120483739736],[173.3757986426927,168.91887376132883],[188.24392801283238,170.15385889611625],[200.12524539616342,178.65251054448225],[173.19598820950318,185.1265364100002],[185.95855151608242,178.81794282230862],[198.4971141117622,187.05374706379993],[185.4377225271597,190.37952024045074],[185.98281490522803,185.20250445906245],[259.5320345390894,185.05971646407426],[246.88376114479686,178.78036057847822],[234.10991631345678,186.96425374558078],[247.3488668011078,190.3875062058208],[247.10619714820044,184.80453033815417],[216.23030075210633,184.86597457146982],[202.1590682676074,216.35233626543047],[196.82249343154,227.22483601295542],[202.23002054577984,234.85312907268107],[216.63308711258765,238.16258826386513],[230.99951500473176,234.8409211439776],[236.37434182521315,227.20671091865114],[231.06242279505696,216.28536342948013],[216.49039954208098,207.50354721394575],[205.87360436510352,231.79219661913382],[227.46633397538858,231.82769368491813],[193.27038057566278,258.5944277943413],[201.8412607695899,258.01857504183124],[208.77610506421038,258.4106354376825],[216.4845747467392,258.19412810125453],[223.70609207661985,258.015005272357],[231.8163939745787,257.2255455056153],[240.75365550737448,257.06760687678735],[234.15068686639268,267.5941118173702],[226.75426860921374,271.7118979182626],[217.00842367188105,272.7454373304957],[207.14167547475247,271.6199347333772],[199.69241662692133,267.55075420690946],[205.78543514106443,262.0061615552903],[216.9516006624897,263.125892309618],[228.0227830793519,262.10131931895205],[228.10418600352676,260.9110213715527],[216.8471763720247,261.62134174301735],[205.4930119846011,260.94094869657744],[216.71821858897425,228.65933713693727],[178.3180048438881,180.36858998668242],[194.02232437039947,181.13557645941654],[192.54969846232765,189.1499239757562],[178.60666307867416,188.64944546430837],[254.49275584042945,180.34191610138723],[238.7694868526886,181.05767716392538],[240.19903965186097,189.0941103681234],[254.1805592784296,188.61862542123973]]
                // data: [[373.6829007309799,333.6033286410444],[364.17314450753906,383.3599984879259],[365.9048165597815,434.0314271265919],[373.2422055935817,487.0699409079492],[388.17252268643904,532.241151936084],[409.7047051276149,571.7682796704901],[436.99972954615396,604.9893863872219],[475.4275975701439,619.9495474889932],[517.5809543124357,614.3772129964813],[554.7717647615224,591.0049876184077],[588.8870218540317,559.3053183765136],[617.6041718614249,518.5713015550733],[637.4268886378318,464.74777708056865],[649.4354060099264,413.471217756884],[648.4620903830812,360.1849951908106],[612.8614403436063,343.1923763834533],[593.2773801400335,333.04957088571496],[560.5777605298512,330.5653508840528],[535.7480939009703,332.83340264474793],[400.0552077192386,324.7609531500231],[416.5113010905239,318.32831883756126],[446.9157469454622,321.3354532936721],[470.1824857252962,327.4877089381385],[416.8568125149038,349.257968620622],[441.1000908833433,337.55982684574167],[464.8680193414503,355.10606560368853],[438.7530834914988,360.28264520892776],[440.65669965980214,348.06742580608585],[590.7130111305238,363.9297336029971],[566.8414663936287,348.00539256069624],[540.7017701913851,361.4428908100841],[565.3101804844033,370.9425566830681],[566.460338284529,358.66281021891376],[500.5793921734156,353.0342439285408],[465.4984497204574,414.033990247578],[451.5767087458774,436.87941813886147],[461.2401620722275,454.1767184899113],[488.4806330280681,463.34262796920103],[520.280339703666,459.60601454774],[533.5998012746328,444.42927525829936],[523.0351119620861,418.98319350049985],[494.2658532665503,397.8445113147608],[467.82780239779294,447.64532411642693],[511.956501741248,450.8923123916977],[445.3824839849693,513.2191210324441],[458.72481759482594,504.53196735659543],[473.64072385168106,501.0182863970015],[485.7065380418388,505.38500482913076],[498.611094285588,503.17406005512794],[515.2274181051795,509.5393708850428],[530.6331803680665,520.9788212860849],[518.7638349796744,531.9402734438872],[502.4671196911854,538.8618291227145],[483.06830038869566,539.5174701018998],[465.27675233448826,535.3618568734344],[452.8226640495862,525.673917497816],[465.4791261963769,517.2902173221328],[484.85024398099534,522.7373163750306],[506.8881733440652,521.0748379772249],[507.27646680502096,515.4101852706132],[485.14406881205036,514.5629889568427],[465.4206051844338,511.7919748440278],[488.58282775055454,440.6894565572102],[426.69352484700147,339.99059471087696],[456.0377447444161,343.2606044311671],[452.58906718477147,358.6082871420145],[426.0062332648082,355.9585740410348],[581.535795007454,352.9428269283827],[551.0199625220066,351.17937326620887],[551.8914509000148,366.8501348887215],[579.2702298407937,368.92930006560834]]
            },
            face1: {
                el: createImg('/static/videosensor/face1.png'),
                data: [[141.91459495110382,177.5443098822513],[139.53721037331522,209.08169014235156],[142.64846619740507,240.06931234175647],[151.58304434487516,270.0944541078911],[165.033041777969,295.82217014427164],[183.24024175333096,314.9688713208382],[206.5526673225216,327.70815749823396],[235.23049264612484,333.0956284637499],[261.8164028842584,332.39731217276324],[287.10369919285375,320.5766178550458],[308.07649850639217,301.0104409654159],[323.1628732775175,275.57142520631305],[331.2214570645823,244.28227522797926],[335.74119222669185,213.4659823671599],[333.8414172013435,181.56422132362138],[310.73232152529033,165.86203723118214],[294.7401193451247,160.16990254470332],[272.4243904659068,161.10530708200946],[254.74142340164119,164.42013531419892],[161.8015741117911,163.6776465635838],[177.5956717467361,157.9373240337888],[199.99379538060288,159.68993612317638],[217.44193932830066,163.79179586602956],[176.30344733824734,183.00288205717695],[194.37704726006646,175.91202709756712],[212.2925811453736,185.12096605540307],[193.7441977755061,188.36577144043798],[194.6918244372754,181.4086492265309],[298.0679264446821,185.6887138956009],[280.5609083250149,177.68427670944888],[261.64089465913383,186.1150832225562],[280.4400588991257,190.27955079970417],[280.93128630833195,183.24324315196972],[237.15767177953092,180.53267625222404],[214.8502456147911,221.7849527851691],[206.30120748123713,235.04136672266097],[213.48131380007084,244.4716337733818],[233.06704264777542,249.5702891436527],[254.47983502402639,245.4843957944222],[262.2037103706621,236.32630676023487],[254.03020540025827,222.70943946054206],[235.89199220760682,208.956288588445],[218.89417506047778,241.06694425720383],[248.17598939745338,241.67412742083192],[197.86360236434342,268.2655030139373],[209.30113163306515,266.2092076862489],[224.023080339351,265.29498954799857],[234.01298070106208,267.5785249669761],[244.04385587071292,265.8678968373752],[259.78093723945943,267.5191899282035],[272.61667804584994,270.90306585242826],[263.7270872184553,282.9729015942435],[251.33464137237377,286.75744788127656],[234.94994775450502,288.6001191674113],[220.1681160034063,286.80002817807434],[207.78376498033185,282.69483603537464],[216.2808871468464,274.7730558361287],[234.48478095143878,276.48932543981226],[254.1156365491001,274.1959740421402],[253.8293239254528,272.85191509937835],[234.26502941894432,273.74030551838763],[216.18758036533413,272.84912536994517],[234.6150015617716,236.0258522619682],[184.19122012032224,177.79539925661328],[205.0700541812486,178.52607560583965],[203.46125264048604,187.26629146485115],[184.28170382910787,186.66436540408705],[290.5972167307091,180.0220866836683],[269.56148350007277,179.7738293214258],[270.67848422657414,188.72947361589993],[290.0424389943219,188.93608324676092]]
            },
            blackcat: {
                el: createImg('/static/videosensor/blackcat.png'),
                data: [[154.20231263579512,168.96044901076948],[150.4508964297691,198.4347959809121],[152.0191998047471,229.49033330353708],[163.33948508901167,258.5630172359312],[177.56424880085606,282.5702599566429],[197.10139750641116,298.0022282831987],[223.0017527572395,308.2111665105158],[244.580724778723,310.82549493292646],[263.88672549858074,311.4628553381864],[288.2237361928282,302.1497123244639],[310.8718212589729,286.2554704907268],[328.8502396891783,262.0306498721426],[340.0422791588152,232.07178867814412],[342.6966601662011,201.0248125436964],[339.05396560044886,170.92042098928653],[319.28451012283205,160.80049593515898],[303.8075144983091,154.9097341149506],[280.77141510001485,157.09219470521234],[263.27900924886984,161.81005701821798],[171.08803904849057,161.04086958184385],[186.50244860389716,154.7080151875841],[209.606492143336,157.09136700951757],[226.874606943045,162.02901108784994],[185.6690210195891,178.73347550355888],[203.21802803954324,171.86316433831314],[221.36269658793705,179.3146876411743],[203.20751899080977,182.79146472301485],[204.26330004871795,176.7276242304508],[306.5911032181898,179.35895728070454],[289.54170231913525,172.1145018785453],[270.6994313017855,179.45405063302493],[289.3148184027264,183.19016571229383],[289.5333862173252,177.03259265033898],[244.57521966712773,174.2416764052258],[222.70238121376778,210.7290934658331],[214.6024651223654,223.41127027671325],[221.66710639019848,232.66860432182196],[242.1038229035032,238.07304315134644],[264.47755281312226,233.14109086649106],[271.8518926895469,224.09293139144106],[263.72947846750617,211.21558395913164],[242.90271370825724,199.97011826642506],[227.6951372501707,230.45735238756706],[257.10457360041175,230.5596198265543],[204.1881781476241,258.218688452331],[218.54552346856244,251.6705359652048],[233.1330951699397,250.09988470387424],[242.9705580809494,252.27838556075181],[252.80173538034109,250.40536829418656],[268.3911265924206,252.29227220973144],[283.8376913354314,259.4569684407943],[271.537001298244,267.708914211297],[258.9129074743551,270.9727973043973],[242.89166960399947,270.08634999862016],[228.87432555455732,269.5942429902333],[218.41998942077888,264.1655209658332],[224.02327848153274,258.62070214461687],[242.65737926790453,261.20601547383984],[263.14291978388684,259.3932845243968],[262.82827261827646,257.8086156383675],[242.88319805706985,258.9454208144934],[223.86975461059836,257.24508513922507],[241.6539561033252,224.3026320324707],[193.30628341127533,173.88548334562466],[213.68513763573057,173.675428596594],[212.69165472857821,181.55954862777946],[193.87781790349678,181.63862852433653],[299.33335434368576,174.23813345305555],[278.8155537873456,173.81574956967893],[279.67378550767774,181.88746001379025],[298.5829684489814,182.0832208662177]]
            },
            yangxinyao: {
                el: createImg('/static/videosensor/yangxinyao.png'),
                data: [[95.88165519145304,141.36572183977063],[93.38383362993117,174.1435441311079],[97.91650196663525,207.39344307207458],[108.00047428988634,240.63720459779182],[124.56648171217114,268.7311140887184],[146.68179854007133,291.90428511890923],[172.14967912033657,310.7186866993141],[200.21608606048295,316.58547260863725],[227.52770152864622,310.3374774485285],[251.4128859308412,291.3757058395665],[272.10462628296267,268.08749059905244],[287.52986798242756,239.8090497637927],[296.51915543909644,205.9827214457223],[300.43550100358107,172.60339575653558],[296.8684073964681,139.87156362941127],[277.82423402839044,118.13411559853586],[262.7054945751207,108.91336679190354],[238.32162761858166,110.7513155437036],[218.83707572278075,116.49221938542846],[114.8591194708691,119.81898951860771],[130.0475845996879,109.91801009189327],[154.86149508096534,111.32834285888198],[174.59032999391923,116.78169925639354],[129.87883349283072,148.32877691741803],[148.57428857538497,140.3171025945037],[169.0597540390835,149.28767734747436],[148.5291647457657,155.1957688589906],[149.87634959958572,147.31468753497103],[264.86026174507964,147.4541870499383],[246.47367041935613,139.66315582853247],[225.67379834344328,148.78894315488265],[246.44850566225176,154.54124615530432],[245.35092118370358,146.6918678840104],[197.25729924468703,140.19777211351771],[176.18661560042705,189.58493232952014],[166.72127824599164,204.4562976192168],[175.15773869901213,214.96999908748464],[198.28136317618905,219.3466592909106],[221.22067905655138,214.55692624113533],[229.37013596661174,203.93141988327267],[219.88205210524671,189.20425512216107],[197.83052970380277,172.37515168899682],[182.4034053308016,209.7401232486518],[214.1931402015629,209.62263613946772],[160.75757123246447,248.4082213940827],[174.983462015411,241.5367597948352],[189.36589742805563,238.21213532417386],[199.10015605326174,240.31915873659705],[208.66561647763677,238.10047090882327],[223.17107424606095,241.188846511662],[237.260286385648,247.95923228432326],[225.61787537275347,254.25324636179676],[213.18174101655956,258.2506397534615],[198.7057600265761,259.6925711894283],[186.87287715249823,258.3421445280326],[174.74709865882215,255.2012029068559],[181.11678221781193,249.8122878141486],[199.1274231741669,250.9277975480391],[216.9537460175432,249.7434711643255],[217.2794020832406,248.35720256940058],[199.1323219867456,248.9885713811227],[180.8648560098358,248.64090698892707],[198.35883890633394,202.36784898496813],[137.77088050195778,142.72098840295212],[160.41741587934817,142.55285356534802],[159.41619854726832,153.09553100424557],[138.01939640234724,153.1827193766194],[257.16731987823,141.9593782390017],[234.55656352649305,141.95629763079035],[235.53372422987223,152.51873458572047],[256.94752324473666,152.36552487264254]]
            },
            loong: {
                el: createImg('/static/videosensor/loong.png'),
                data: [[156.92119079649595,183.32046602282645],[154.57731708067757,213.3308407164486],[157.21469583423192,242.83277641711106],[163.52007852538495,272.7366317138609],[174.82412408398832,297.96174986621327],[190.26779768533342,320.26217722312947],[210.33875796050057,337.89709438762594],[236.2335037774327,343.6937433820916],[262.9986110183864,338.3613870923576],[284.4505870188443,321.1583646354259],[301.5373174758362,299.44020884937004],[313.88662044312093,274.435603415414],[320.2618959808579,244.83914831536026],[323.6364633821307,215.40681985953785],[320.92716290448834,184.66173709800665],[303.5302344417872,163.68511518153656],[290.13086747257853,158.29895518900534],[270.7265569655604,158.6681375969972],[255.30746287539296,161.02629915017562],[171.2250034121304,164.29539784553143],[184.3777329874134,158.3731635278587],[203.8260718092764,158.7799334947258],[219.1089307494612,161.25193529363654],[183.26811022040795,183.30985202978297],[198.9644565892283,175.14725046552903],[215.15936049123061,184.88725821311317],[198.3872423182789,188.227278557847],[199.51803125712885,181.56675829356513],[293.90098295453737,183.6646893911076],[278.6884288625598,175.21554483400675],[261.6329185696917,184.8612786672045],[278.86973599441103,188.46787866666506],[279.0564485067087,181.7141802309618],[236.93520075941998,180.66469668729104],[218.39531295877038,224.96052327761416],[210.96217775158925,238.51526972265808],[217.7703318420071,247.52761828434345],[234.94817254050176,251.58786905649706],[253.9469469684807,247.78681774400962],[260.98569662448256,238.86025653310665],[253.51981510037584,225.22600528321507],[235.55800165632124,209.7453607231617],[221.58777669699757,242.69456895340133],[248.94128109728766,242.7574845566396],[204.89823359385935,280.55132852378955],[217.66225261846674,275.48988389272245],[227.26855809845932,276.339667325188],[236.5666449603734,277.29257234544406],[246.55984251348704,276.9394293388345],[257.32315731706535,276.24712246090513],[269.8396120893219,280.1706128385522],[261.6131422334793,284.8259247362342],[250.62973610421616,289.4436661269408],[236.60515008520107,291.01708409582324],[223.12138482267235,289.1803757549849],[212.8320175658941,284.34836130503953],[220.87031821800036,281.6355218647156],[237.0152906584266,283.46407981154744],[251.5474890977484,282.7618125230951],[251.57826510354982,281.38877848046906],[236.94031508531154,281.56839483098537],[221.24175385128981,279.8861966637569],[234.5004233218064,237.3633295083518],[189.67502769166248,177.32573396052857],[208.62182081631838,177.9108385119836],[207.06210301680304,186.95001655508239],[189.7698602264611,186.59892633600916],[287.85115584281834,177.48122949383063],[268.7392267259944,177.84893297162793],[270.07229399745853,187.11363526606507],[287.54522130632944,186.8261489120141]]
            },
            Dr_bear: {
                el: createImg('/static/videosensor/Dr_bear.png'),
                data: [[154.1148284110931,195.87426099022235],[152.42146458182546,223.70325210090462],[155.11987224663093,251.06887788945946],[160.8112950369988,278.7561172067547],[171.78008125747056,301.5939973653659],[187.3971278291388,320.49099013257415],[206.97229619908381,335.3236407824779],[231.65853567136173,340.5526527511821],[257.33712568591767,335.90199022318217],[278.71806270798925,321.59591336735633],[296.2614720411216,303.25598740034366],[308.58399750743035,280.5854439494373],[314.7052047444485,253.1122281442532],[318.13054257196103,225.73081610613252],[316.3286189030653,197.24903058064825],[299.0348797516374,180.33681337874913],[285.35484237739615,175.3535844977582],[265.91820586026716,176.53922486963734],[250.76853768796087,179.67221886866665],[168.11718982748997,180.58444681699117],[181.38804187059654,175.2528399293514],[200.77997051985471,176.52117404186777],[215.7472268336322,179.79093926172933],[180.055594141666,197.94902117490207],[195.4791592289082,190.9739050138441],[211.54332157205036,199.084115841681],[195.1809276116624,202.25457268420303],[196.12795970503777,196.1433513320196],[288.7741716609714,198.42459700675076],[273.60568406457514,191.16928257587787],[256.9269994226387,199.19218880137478],[273.68211621044935,202.61509289750757],[273.8548991376537,196.4125270547817],[232.9480632905161,194.9599689033528],[214.73461927991326,233.117086886701],[207.6100434252865,245.32560774497256],[214.0554989273892,253.7570443823256],[231.0550045825582,257.8108108095829],[249.71425977285713,254.10944763077873],[256.45827019088347,245.7805066095327],[249.24943949215952,233.43479482978387],[231.62567088690534,220.65328759173892],[218.26022436799585,249.94001895276975],[244.37398671758396,250.0035408136587],[199.8381547265428,278.982247085974],[211.43625658826178,273.6027482368117],[223.43148695021412,272.10651681326146],[231.8049604489733,273.82320544429274],[240.1601113198938,272.3165864282332],[253.10067684280057,274.028883061385],[265.9059339262443,279.8213724854094],[257.0307101753167,286.8918385324233],[246.01832548667352,291.27728852054673],[232.0010056335005,292.7233765550727],[218.47144592160646,291.0175432070022],[208.15336241644826,286.36796877596817],[216.25480343166853,281.3709791247414],[232.0661993547597,283.11185778349443],[248.5331904430507,281.69899669370807],[247.98066863852085,278.65614760131604],[231.7807947571751,279.71835674295534],[216.36706473299043,278.2754370921821],[230.60670631801358,245.00521302275374],[186.51556211103448,192.88766146859112],[204.90563203799454,193.18038421607488],[203.65264021443207,201.0454555085554],[186.8253918464498,200.88566520417015],[282.5253846444675,193.1754564793512],[263.9591919597958,193.273395674525],[265.0840909349189,201.3195295579363],[282.0665216315919,201.26419127530716]]
            },
            v: {
                el: createImg('/static/videosensor/vendetta.jpg'),
                data: [[116.45255510813566,211.6722654101634],[118.05298684767486,273.85356000525877],[125.77363024878385,338.960075955346],[145.85677429827615,398.38502895073145],[183.09950563842088,452.3440956261004],[229.48764073502065,506.03093215133475],[256.86155960742656,528.7213070410896],[292.29226896023926,540.3605100000001],[327.65230620629904,527.36973],[356.02385875615454,504.34062000000006],[409.9965409976276,451.9952837204363],[449.2382344772338,396.0557740344723],[468.05033680765627,341.09836596063656],[477.5836822950182,277.82166364810564],[477.34439674050657,213.76397997460575],[442.7587998841553,148.30564456531116],[405.1829657116629,128.9663572356396],[358.9703099559231,136.06623185702807],[323.29236205923627,159.7209702267879],[143.0035215077407,146.50436676839993],[176.14032809643953,123.71187597256183],[219.15661440231426,134.1105942513657],[260.7468308255621,159.8662602818062],[166.77809830265477,211.23631779121408],[206.5807831540388,192.28100121594906],[248.74079258035158,208.43119605934052],[208.16955971222094,222.2829382211836],[208.16220730902444,208.10202802676307],[416.61422730721114,219.01372955840012],[381.86864988836453,199.22660207574884],[337.6797299089405,212.66991108567703],[379.08667077753574,228.8821242959545],[381.0742633627316,215.0061813578744],[294.4411163879064,199.38551692182796],[251.63716422137398,271.5681368950506],[231.92056989432854,291.76325233395033],[243.01194791608938,319.3604611827597],[298.1448445620611,327.14946395230425],[345.73541541846566,323.34788595037236],[352.3529780813749,297.6586880093225],[333.1713106824827,274.1761051471009],[294.8898908887052,247.30816615243813],[258.0665376018602,310.8333080934209],[333.09878211401406,316.1382272019894],[206.27162991776973,374.49591795910214],[252.0232643898619,361.36308205960205],[277.5759102384524,361.9948518709568],[296.95871790185623,366.1065091582501],[315.77786074988495,361.54209265886533],[341.53470295926155,364.4133656609533],[378.9491360865858,379.9552783482704],[358.4576962406762,399.86129180814606],[329.8644867028667,407.3553290942636],[293.2339144181517,406.48098447830665],[257.0759456936365,404.95004920759834],[228.04167672888468,400.62941147834044],[268.8074450567075,379.88407736126874],[296.0804693407592,381.3226558200121],[318.76882035495873,381.3911274055823],[318.6345689693104,375.90995782621223],[296.4053653663204,378.1543502745987],[268.04816238355727,374.15838970560435],[296.2587939149006,297.4244628465378],[182.49417207479195,197.04556764120926],[230.5938482058522,196.68160256654093],[230.62026064158528,218.97368143437066],[185.55468726393119,221.42851100404363],[402.5792850844394,206.00374545399035],[359.92288439755373,202.07866282495127],[357.1728943748146,223.66040194325873],[400.22026446918727,226.1731016693131]]
            }
        }
    }

    /**
     * After analyzing a frame the amount of milliseconds until another frame
     * is analyzed.
     * @type {number}
     */
    static get INTERVAL () {
        return 33;
    }

    /**
     * Dimensions the video stream is analyzed at after its rendered to the
     * sample canvas.
     * @type {Array.<number>}
     */
    static get DIMENSIONS () {
        return [480, 360];
    }

    /**
     * The key to load & store a target's motion-related state.
     * @type {string}
     */
    static get STATE_KEY () {
        return 'Scratch.videoSensing';
    }

    /**
     * The default motion-related state, to be used when a target has no existing motion state.
     * @type {MotionState}
     */
    static get DEFAULT_MOTION_STATE () {
        return {
            motionFrameNumber: 0,
            motionAmount: 0,
            motionDirection: 0
        };
    }

    /**
     * The transparency setting of the video preview stored in a value
     * accessible by any object connected to the virtual machine.
     * @type {number}
     */
    get globalVideoTransparency () {
        const stage = this.runtime.getTargetForStage();
        if (stage) {
            return stage.videoTransparency;
        }
        return 50;
    }

    set globalVideoTransparency (transparency) {
        const stage = this.runtime.getTargetForStage();
        if (stage) {
            stage.videoTransparency = transparency;
        }
        return transparency;
    }

    /**
     * The video state of the video preview stored in a value accessible by any
     * object connected to the virtual machine.
     * @type {number}
     */
    get globalVideoState () {
        const stage = this.runtime.getTargetForStage();
        if (stage) {
            return stage.videoState;
        }
        // Though the default value for the stage is normally 'on', we need to default
        // to 'off' here to prevent the video device from briefly activating
        // while waiting for stage targets to be installed that say it should be off
        return VideoState.OFF;
    }

    set globalVideoState (state) {
        const stage = this.runtime.getTargetForStage();
        if (stage) {
            stage.videoState = state;
        }
        return state;
    }

    /**
     * Get the latest values for video transparency and state,
     * and set the video device to use them.
     */
    updateVideoDisplay () {
        this.setVideoTransparency({
            TRANSPARENCY: this.globalVideoTransparency
        });
        this.videoToggle({
            VIDEO_STATE: this.globalVideoState
        });
    }

    /**
     * Reset the extension's data motion detection data. This will clear out
     * for example old frames, so the first analyzed frame will not be compared
     * against a frame from before reset was called.
     */
    reset () {
        this.detect.reset();

        const targets = this.runtime.targets;
        for (let i = 0; i < targets.length; i++) {
            const state = targets[i].getCustomState(Scratch3VideoSensingBlocks.STATE_KEY);
            if (state) {
                state.motionAmount = 0;
                state.motionDirection = 0;
            }
        }
    }

    /**
     * Occasionally step a loop to sample the video, stamp it to the preview
     * skin, and add a TypedArray copy of the canvas's pixel data.
     * @private
     */
    _loop () {
        setTimeout(this._loop.bind(this), Math.max(this.runtime.currentStepTime, Scratch3VideoSensingBlocks.INTERVAL));

        // Add frame to detector
        const time = Date.now();
        if (this._lastUpdate === null) {
            this._lastUpdate = time;
        }
        const offset = time - this._lastUpdate;
        if (offset > Scratch3VideoSensingBlocks.INTERVAL) {
            const frame = this.runtime.ioDevices.video.getFrame({
                format: Video.FORMAT_IMAGE_DATA,
                dimensions: Scratch3VideoSensingBlocks.DIMENSIONS
            });
            if (frame) {
                this._lastUpdate = time;
                this.detect.addFrame(frame.data);
            }
        }
    }

    /**
     * Create data for a menu in scratch-blocks format, consisting of an array
     * of objects with text and value properties. The text is a translated
     * string, and the value is one-indexed.
     * @param {object[]} info - An array of info objects each having a name
     *   property.
     * @return {array} - An array of objects with text and value properties.
     * @private
     */
    _buildMenu (info) {
        return info.map((entry, index) => {
            const obj = {};
            obj.text = entry.name;
            obj.value = entry.value || String(index + 1);
            return obj;
        });
    }

    /**
     * @param {Target} target - collect motion state for this target.
     * @returns {MotionState} the mutable motion state associated with that
     *   target. This will be created if necessary.
     * @private
     */
    _getMotionState (target) {
        let motionState = target.getCustomState(Scratch3VideoSensingBlocks.STATE_KEY);
        if (!motionState) {
            motionState = Clone.simple(Scratch3VideoSensingBlocks.DEFAULT_MOTION_STATE);
            target.setCustomState(Scratch3VideoSensingBlocks.STATE_KEY, motionState);
        }
        return motionState;
    }

    static get SensingAttribute () {
        return SensingAttribute;
    }

    /**
     * An array of choices of whether a reporter should return the frame's
     * motion amount or direction.
     * @type {object[]}
     * @param {string} name - the translatable name to display in sensor
     *   attribute menu
     * @param {string} value - the serializable value of the attribute
     */
    get ATTRIBUTE_INFO () {
        return [
            {
                name: formatMessage({
                    id: 'videoSensing.motion',
                    default: 'motion',
                    description: 'Attribute for the "video [ATTRIBUTE] on [SUBJECT]" block'
                }),
                value: SensingAttribute.MOTION
            },
            {
                name: formatMessage({
                    id: 'videoSensing.direction',
                    default: 'direction',
                    description: 'Attribute for the "video [ATTRIBUTE] on [SUBJECT]" block'
                }),
                value: SensingAttribute.DIRECTION
            }
        ];
    }

    static get SensingSubject () {
        return SensingSubject;
    }

    /**
     * An array of info about the subject choices.
     * @type {object[]}
     * @param {string} name - the translatable name to display in the subject menu
     * @param {string} value - the serializable value of the subject
     */
    get SUBJECT_INFO () {
        return [
            {
                name: formatMessage({
                    id: 'videoSensing.sprite',
                    default: 'sprite',
                    description: 'Subject for the "video [ATTRIBUTE] on [SUBJECT]" block'
                }),
                value: SensingSubject.SPRITE
            },
            {
                name: formatMessage({
                    id: 'videoSensing.stage',
                    default: 'stage',
                    description: 'Subject for the "video [ATTRIBUTE] on [SUBJECT]" block'
                }),
                value: SensingSubject.STAGE
            }
        ];
    }

    /**
     * States the video sensing activity can be set to.
     * @readonly
     * @enum {string}
     */
    static get VideoState () {
        return VideoState;
    }

    /**
     * An array of info on video state options for the "turn video [STATE]" block.
     * @type {object[]}
     * @param {string} name - the translatable name to display in the video state menu
     * @param {string} value - the serializable value stored in the block
     */
    get VIDEO_STATE_INFO () {
        return [
            {
                name: formatMessage({
                    id: 'videoSensing.off',
                    default: 'off',
                    description: 'Option for the "turn video [STATE]" block'
                }),
                value: VideoState.OFF
            },
            {
                name: formatMessage({
                    id: 'videoSensing.on',
                    default: 'on',
                    description: 'Option for the "turn video [STATE]" block'
                }),
                value: VideoState.ON
            },
            {
                name: formatMessage({
                    id: 'videoSensing.onFlipped',
                    default: 'on flipped',
                    description: 'Option for the "turn video [STATE]" block that causes the video to be flipped' +
                        ' horizontally (reversed as in a mirror)'
                }),
                value: VideoState.ON_FLIPPED
            }
        ];
    }

    /**
     * @returns {object} metadata for this extension and its blocks.
     */
    getInfo () {
        // Set the video display properties to defaults the first time
        // getInfo is run. This turns on the video device when it is
        // first added to a project, and is overwritten by a PROJECT_LOADED
        // event listener that later calls updateVideoDisplay
        if (this.firstInstall) {
            this.globalVideoState = VideoState.ON;
            this.globalVideoTransparency = 50;
            this.updateVideoDisplay();
            this.firstInstall = false;
        }

        // Return extension definition
        return {
            id: 'videoSensing',
            name: formatMessage({
                id: 'videoSensing.categoryName',
                default: 'Video Sensing',
                description: 'Label for the video sensing extension category'
            }),
            blockIconURI: blockIconURI,
            menuIconURI: menuIconURI,
            blocks: [
                {
                    // @todo this hat needs to be set itself to restart existing
                    // threads like Scratch 2's behaviour.
                    opcode: 'whenMotionGreaterThan',
                    text: formatMessage({
                        id: 'videoSensing.whenMotionGreaterThan',
                        default: 'when video motion > [REFERENCE]',
                        description: 'Event that triggers when the amount of motion is greater than [REFERENCE]'
                    }),
                    blockType: BlockType.HAT,
                    arguments: {
                        REFERENCE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 10
                        }
                    }
                },
                {
                    opcode: 'videoOn',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'videoSensing.videoOn',
                        default: 'video [ATTRIBUTE] on [SUBJECT]',
                        description: 'Reporter that returns the amount of [ATTRIBUTE] for the selected [SUBJECT]'
                    }),
                    arguments: {
                        ATTRIBUTE: {
                            type: ArgumentType.NUMBER,
                            menu: 'ATTRIBUTE',
                            defaultValue: SensingAttribute.MOTION
                        },
                        SUBJECT: {
                            type: ArgumentType.NUMBER,
                            menu: 'SUBJECT',
                            defaultValue: SensingSubject.SPRITE
                        }
                    }
                },
                {
                    opcode: 'videoToggle',
                    text: formatMessage({
                        id: 'videoSensing.videoToggle',
                        default: 'turn video [VIDEO_STATE]',
                        description: 'Controls display of the video preview layer'
                    }),
                    arguments: {
                        VIDEO_STATE: {
                            type: ArgumentType.NUMBER,
                            menu: 'VIDEO_STATE',
                            defaultValue: VideoState.ON
                        }
                    }
                },
                {
                    opcode: 'setVideoTransparency',
                    text: formatMessage({
                        id: 'videoSensing.setVideoTransparency',
                        default: 'set video transparency to [TRANSPARENCY]',
                        description: 'Controls transparency of the video preview layer'
                    }),
                    arguments: {
                        TRANSPARENCY: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 50
                        }
                    }
                },
                '---',
                {
                    opcode: 'faceTrack',
                    text: '人脸检测 [TRACKER_STATE]',
                    arguments: {
                        TRACKER_STATE: {
                            type: ArgumentType.NUMBER,
                            menu: 'TRACKER_STATE',
                            defaultValue: 'on'
                        }
                    }
                }, 
                {
                    opcode: 'faceDetect',
                    text: '检测调试 [DETECT_STATE]',
                    arguments: {
                        DETECT_STATE: {
                            type: ArgumentType.NUMBER,
                            menu: 'DETECT_STATE',
                            defaultValue: 'on'
                        }
                    }
                }, {
                    opcode: 'setMask',
                    text: '戴面具 [CURRENT_MASK]',
                    arguments: {
                        CURRENT_MASK: {
                            type: ArgumentType.STRING,
                            menu: 'MASK_LIST',
                            defaultValue: 'ironman'
                        }
                    }
                },
                {
                    opcode: 'facePosition',
                    blockType: BlockType.REPORTER,
                    text: '人脸位置[POSITION][LOCATION]',
                    arguments: {
                        POSITION: {
                            type: ArgumentType.STRING,
                            menu: 'POSITION_LIST',
                            defaultValue: 'left',
                        },
                        LOCATION: {
                            type: ArgumentType.STRING,
                            menu: 'LOCATION_LIST',
                            defaultValue: 'x',
                        }
                    }
                },
                // {
                //     opcode: 'maskMount',
                //     blockType: BlockType.REPORTER,
                //     text: '面具数据'
                // }
            ],
            menus: {
                ATTRIBUTE: {
                    acceptReporters: true,
                    items: this._buildMenu(this.ATTRIBUTE_INFO)
                },
                SUBJECT: {
                    acceptReporters: true,
                    items: this._buildMenu(this.SUBJECT_INFO)
                },
                VIDEO_STATE: {
                    acceptReporters: true,
                    items: this._buildMenu(this.VIDEO_STATE_INFO)
                },
                TRACKER_STATE: {
                    acceptReporters: true,
                    items: [
                        { text: '开启', value: 'on' },
                        { text: '关闭', value: 'off' },
                        // { text: '镜像', value: 'mirror' },
                    ]
                },
                DETECT_STATE: {
                    acceptReporters: true,
                    items: [
                        { text: '开启', value: 'on' },
                        { text: '关闭', value: 'off' },
                        // { text: '镜像', value: 'mirror' },
                    ]
                },
                MASK_LIST: {
                    acceptReporters: true,
                    items: [
                        { text: '美猴王', value: 'monkeyking' },
                        { text: '脸谱', value: 'face1' },
                        { text: '黑猫警长', value: 'blackcat' },
                        // { text: '杨鑫瑶', value: 'yangxinyao' },
                        { text: '熊博士', value: 'Dr_bear' },
                        { text: '龙', value: 'loong' },
                        // { text: 'V', value: 'v' },
                        { text: '蒙娜丽莎', value: 'monalisa' },
                        { text: '钢铁侠', value: 'ironman' },
                        { text: '关闭', value: 'off' },
                    ]
                },
                POSITION_LIST: {
                    acceptReporters: true,
                    items: [
                        { text: 'left', value: 'left' },
                        { text: 'right', value: 'right' },
                        { text: 'bottom', value: 'bottom' },
                        { text: 'mouth', value: 'mouth' },
                        { text: 'nose', value: 'nose' },
                        { text: 'left_eye', value: 'left_eye' },
                        { text: 'right_eye', value: 'right_eye' },
                    ]
                },
                LOCATION_LIST: {
                    acceptReporters: true,
                    items: [
                        { text: 'x', value: 'x' },
                        { text: 'y', value: 'y' },
                    ]
                }
                
            }
        };
    }

    /**
     * Analyze a part of the frame that a target overlaps.
     * @param {Target} target - a target to determine where to analyze
     * @returns {MotionState} the motion state for the given target
     */
    _analyzeLocalMotion (target) {
        const drawable = this.runtime.renderer._allDrawables[target.drawableID];
        const state = this._getMotionState(target);
        this.detect.getLocalMotion(drawable, state);
        return state;
    }

    /**
     * A scratch reporter block handle that analyzes the last two frames and
     * depending on the arguments, returns the motion or direction for the
     * whole stage or just the target sprite.
     * @param {object} args - the block arguments
     * @param {BlockUtility} util - the block utility
     * @returns {number} the motion amount or direction of the stage or sprite
     */
    videoOn (args, util) {
        this.detect.analyzeFrame();

        let state = this.detect;
        if (args.SUBJECT === SensingSubject.SPRITE) {
            state = this._analyzeLocalMotion(util.target);
        }

        if (args.ATTRIBUTE === SensingAttribute.MOTION) {
            return state.motionAmount;
        }
        return state.motionDirection;
    }

    /**
     * A scratch hat block edge handle that analyzes the last two frames where
     * the target sprite overlaps and if it has more motion than the given
     * reference value.
     * @param {object} args - the block arguments
     * @param {BlockUtility} util - the block utility
     * @returns {boolean} true if the sprite overlaps more motion than the
     *   reference
     */
    whenMotionGreaterThan (args, util) {
        this.detect.analyzeFrame();
        const state = this._analyzeLocalMotion(util.target);
        return state.motionAmount > Number(args.REFERENCE);
    }

    /**
     * A scratch command block handle that configures the video state from
     * passed arguments.
     * @param {object} args - the block arguments
     * @param {VideoState} args.VIDEO_STATE - the video state to set the device to
     */
    videoToggle (args) {
        const state = args.VIDEO_STATE;
        this.globalVideoState = state;
        if (state === VideoState.OFF) {
            this.runtime.ioDevices.video.disableVideo();
            this.faceTrack({TRACKER_STATE: 'off'})
        } else {
            this.runtime.ioDevices.video.enableVideo();
            // Mirror if state is ON. Do not mirror if state is ON_FLIPPED.
            this.runtime.ioDevices.video.mirror = state === VideoState.ON;
            this.video = this.runtime.ioDevices.video.provider.video

            this.fitMirror();
        }
    }

    /**
     * A scratch command block handle that configures the video preview's
     * transparency from passed arguments.
     * @param {object} args - the block arguments
     * @param {number} args.TRANSPARENCY - the transparency to set the video
     *   preview to
     */
    setVideoTransparency (args) {
        const transparency = Cast.toNumber(args.TRANSPARENCY);
        this.globalVideoTransparency = transparency;
        this.runtime.ioDevices.video.setPreviewGhost(transparency);
    }

    insertDrawer () {
        if (!this._skinId) {
            this._skinId = this.renderer.createBitmapSkin(new ImageData(...Scratch3VideoSensingBlocks.DIMENSIONS), 1);
            this._drawable = this.renderer.createDrawable(StageLayering.VIDEO_LAYER);
            this.renderer.updateDrawableProperties(this._drawable, {
                skinId: this._skinId
            });
        }
        if (!this._skinId2) {
            this._skinId2 = this.renderer.createBitmapSkin(new ImageData(...Scratch3VideoSensingBlocks.DIMENSIONS), 1);
            this._drawable2 = this.renderer.createDrawable(StageLayering.VIDEO_LAYER);
            this.renderer.updateDrawableProperties(this._drawable2, {
                skinId: this._skinId2
            });
        }
    }
    // 适应镜像跟大小
    fitMirror() {
        this.mirror = this.runtime.ioDevices.video.mirror
        console.log('this.mirror', this.mirror)
        if(!this.video) {
            this.video = this.runtime.ioDevices.video.provider.video
        }
        if (!this.video) {
            return false
        }
        this.video.width = this.renderer_canvas.scrollWidth//this._video.videoWidth
        this.video.height = this.renderer_canvas.scrollHeight//this._video.videoHeight
        this._canvas.width = this.renderer_canvas.scrollWidth
        this._canvas.height = this.renderer_canvas.scrollHeight
        this._wgl.width = this.renderer_canvas.scrollWidth
        this._wgl.height = this.renderer_canvas.scrollHeight
        this._wglcanvas.width = this.renderer_canvas.scrollWidth
        this._wglcanvas.height = this.renderer_canvas.scrollHeight
        if (this.mirror) {
            let _context = this._canvas.getContext('2d')
            _context.scale(-1, 1);
            _context.translate(this._canvas.width * -1, 0);

            let _context2 = this._wgl.getContext('webgl')
            _context2.viewport(0, 0, this._wgl.width, this._wgl.height);
            // _context2.scale(-1, 1);
            // _context2.translate(this._canvas.width * -1, 0);
        }
        if (!this.mirror) {
            let _context = this._canvas.getContext('2d')
            _context.scale(-1, 1);
            _context.translate(this._canvas.width * -1, 0);
            _context.scale(-1, 1);
            _context.translate(this._canvas.width * -1, 0);

            let _context2 = this._wgl.getContext('webgl')
            _context2.viewport(0, 0, this._wgl.width, this._wgl.height);
            // _context2.scale(-1, 1);
            // _context2.translate(this._canvas.width * -1, 0);
            // _context2.scale(-1, 1);
            // _context2.translate(this._canvas.width * -1, 0);
        }
        return true
    }
    startTrack() {
        if (this.ReqId || this.ReqId2) {
            this.ctracker.start(this.video);
        }
    }

    // this.masks
    switchMasks(maskname) {
        // fd.load(document.getElementById(maskname), masks[maskname], pModel);
        if (maskname == 'off') {
            
        }

        this.fd.load(this.masks[maskname]['el'], this.masks[maskname]['data'], pModel)
    }

    drawMaskLoop() {

        let canvas = this._wgl
        let context = canvas.getContext('webgl')
        let ctracker = this.ctracker
        cancelAnimationFrame(this.ReqId2);
        if (this.currentMask == 'off') {
            this.ReqId2 = null;
            return;
        }
        let positions = ctracker.getCurrentPosition();
        context.clear(context.COLOR_BUFFER_BIT);
        
        //psrElement.innerHTML = "score :" + ctrack.getScore().toFixed(4);
        if (positions) {
            let npositions = positions
            if (this.mirror) {
                npositions = positions.map(i=>{
                    return [canvas.width - i[0], i[1]]
                })
            }
            
            this.fd.draw(npositions);

            let renderer = this.renderer
            this.insertDrawer()
            // this.lastModified = canvas.ownerDocument.lastModified
            if ((Date.now() - this.lastModified) > 33) {
                // 大于33ms才允许刷新
                let _canvas = this._wglcanvas
                let __context = _canvas.getContext('2d')
                __context.clearRect(0, 0, canvas.width, canvas.height);
                
                // let _context = canvas.getContext('webgl', {preserveDrawingBuffer: true})
                // let pixels = new Uint8Array(canvas.width * canvas.height * 4);
                // _context.readPixels(0, 0, canvas.width, canvas.height, _context.RGBA, _context.UNSIGNED_BYTE, pixels); 
                // let imagedata = new ImageData(new Uint8ClampedArray(pixels), canvas.width, canvas.height);

                this.lastModified = Date.now()
                _canvas.getContext('2d').drawImage(canvas, 0, 0, canvas.width, canvas.height)
                // renderer.updateBitmapSkin(this._skinId2, imagedata, 1);
                renderer.updateBitmapSkin(this._skinId2, _canvas, 1);
                // this.drawableID = this.renderer.createDrawable(StageLayering.SPRITE_LAYER);
            } 
        }
        // console.log('positions --> ', positions)
        // ctracker.draw(canvas);
        // let pn = ctracker.getConvergence();
        // if (pn < 0.4) {
        //     this.switchMasks(this.currentMask);
        //     // requestAnimFrame(drawMaskLoop);
        // }
        //  else {
        //     requestAnimFrame(drawGridLoop);
        // }
        this.ReqId2 = requestAnimationFrame(this.drawMaskLoop.bind(this));

        // animationRequest = requestAnimFrame(drawMaskLoop);
    }
    positionLoop() {
        // this.renderer.draw()
        // let canvas = this.renderer.gl.canvas
        let canvas = this._canvas
        let context = canvas.getContext('2d')
        let ctracker = this.ctracker
        cancelAnimationFrame(this.ReqId);
        if (this.faceDetectState == 'off') {
            this.ReqId = null;
            return;
        }
        let positions = ctracker.getCurrentPosition();
        context.clearRect(0, 0, canvas.width, canvas.height);
        // if (this.mirror) {
        //     context.scale(-1, 1);
        //     context.translate(canvas.width * -1, 0);
        // }
        
        //psrElement.innerHTML = "score :" + ctrack.getScore().toFixed(4);
        if (positions) {
            ctracker.draw(canvas);

            let renderer = this.renderer
            this.insertDrawer()
            // this.lastModified = canvas.ownerDocument.lastModified
            if ((Date.now() - this.lastModified) > 33) {
                // 大于33ms才允许刷新
                let _context = canvas.getContext('2d')
                this.lastModified = Date.now()
                // if(this.mirror) {
                //     _context.scale(-1, 1);
                //     _context.translate(canvas.width * -1, 0);
                // }
                let imagedata = _context.getImageData(0, 0, canvas.width, canvas.height);
                renderer.updateBitmapSkin(this._skinId, imagedata, 1);
                // this.drawableID = this.renderer.createDrawable(StageLayering.SPRITE_LAYER);
            } 
        }
        // console.log('positions --> ', positions)
        // ctracker.draw(canvas);
        return this.ReqId = requestAnimationFrame(this.positionLoop.bind(this));
    }

    faceTrack(args) {
        if (!this.video) {
            this.video = this.runtime.ioDevices.video.provider._video
        }
        if (!this.video) {
            console.log('视频未开启')
            return 
            // return alert('视频未启动')
        }
        this.video.width = this.renderer_canvas.scrollWidth
        this.video.height = this.renderer_canvas.scrollHeight
        this.tracker_state = args.TRACKER_STATE
        this.ctracker.stop();
        this.ctracker.reset();
        if (args.TRACKER_STATE == 'on') {
            this.ctracker.start(this.video);
            return new Promise(resolve => {
                let _interval = setInterval(()=>{
                    if (this.ctracker.getCurrentPosition()) {
                        clearInterval(_interval)
                        return resolve()
                    }
                }, 100)
            })
        }
        if (args.TRACKER_STATE == 'off') {
            this.faceDetect({DETECT_STATE: 'off'})
            this.setMask({CURRENT_MASK: 'off'})
        }
    }
    faceDetect(args) {
        // let canvas = this.renderer.gl.canvas
        // let context = canvas.getContext('2d')
        // this.runtime.workspace.canvas
        if (args.DETECT_STATE != 'off' && this.tracker_state == 'off') {
            console.log('请先打开人脸检测')
            return 
            // return alert('请先打开人脸检测');
        }
        if (!this.video) {
            this.video = this.runtime.ioDevices.video.provider._video
        }
        if (args.DETECT_STATE != 'off' && !this.video) {
            // return alert('请先打开视频侦测');
            console.log('请先打开人脸检测')
            return 
        }

        this._canvas.width = this.renderer_canvas.scrollWidth
        this._canvas.height = this.renderer_canvas.scrollHeight

        const state = args.DETECT_STATE;
        this.faceDetectState = state;
        this.ctracker.stop();
        this.ctracker.reset();
        if (state === 'off') {
            this.startTrack();
            let canvas = this._canvas
            let context = canvas.getContext('2d')
            context.clearRect(0, 0, canvas.width, canvas.height);
            this.renderer.updateBitmapSkin(this._skinId, canvas, 1);
        } else {
            if(this.globalVideoState == 'off') {
                console.log('请先打开视频侦测')
                return 
                // return alert('请先打开视频侦测');
            }
            this.video.width = this.renderer_canvas.scrollWidth
            this.video.height = this.renderer_canvas.scrollHeight
            this.ctracker.start(this.video);
            this.fitMirror();
            this.positionLoop();
        }
    }
    setMask(args) {
        if (args.CURRENT_MASK != 'off' && this.tracker_state == 'off') {
            // return alert('请先打开人脸检测');
            console.log('请先打开人脸检测')
            return 
        }
        this.currentMask = args.CURRENT_MASK
        if (!this.video) {
            this.video = this.runtime.ioDevices.video.provider._video
        }
        if (args.CURRENT_MASK != 'off' && !this.video) {
            // return alert('请先打开视频侦测'); 
            console.log('请先打开视频侦测')
            return
        }

        this._wgl.width = this.renderer_canvas.scrollWidth
        this._wgl.height = this.renderer_canvas.scrollHeight
        this._wglcanvas.width = this.renderer_canvas.scrollWidth
        this._wglcanvas.height = this.renderer_canvas.scrollHeight

        this.ctracker.stop();
        this.ctracker.reset();
        if (this.currentMask === 'off') {
            this.startTrack();
            let canvas = this._wglcanvas
            let context = canvas.getContext('2d')
            context.clearRect(0, 0, canvas.width, canvas.height);
            this.renderer.updateBitmapSkin(this._skinId2, canvas, 1);
        } else {
            this.video.width = this.renderer_canvas.scrollWidth
            this.video.height = this.renderer_canvas.scrollHeight
            this.ctracker.start(this.video);
            this.fitMirror();
            this.switchMasks(args.CURRENT_MASK)
            this.drawMaskLoop();
        }
        
    }

    facePosition(args) {
        // POSITION
        // LOCATION
        let result = ''
        if (this.tracker_state == 'off') {
            return '人脸检测未开启'
        }
        const position_map = {
            'left': 14,
            'right': 0,
            'bottom': 7,
            'mouth': 60,
            'nose': 62,
            'left_eye': 32,
            'right_eye': 27
        }
        const location_map = {
            x: 0,
            y: 1
        }
        let locationOffset = Scratch3VideoSensingBlocks.DIMENSIONS[location_map[args.LOCATION]]/2
        let ctracker = this.ctracker
        let positions = ctracker.getCurrentPosition();
        if (positions) {
            let position = positions[position_map[args.POSITION]][location_map[args.LOCATION]]
            if (!this.mirror && args.LOCATION == 'x') {
                position = Scratch3VideoSensingBlocks.DIMENSIONS[location_map[args.LOCATION]] - position
            }
            result = locationOffset - position
        }
        return result
    }

    maskMount(args) {
        if (this.tracker_state == 'off') {
            return '人脸检测未开启'
        }
        // ctrack.start(document.getElementById('image'));
        // let locationOffset = Scratch3VideoSensingBlocks.DIMENSIONS[location_map[args.LOCATION]]/2
        let ctracker = this.ctracker
        let positions = ctracker.getCurrentPosition();

        return positions
    }
    
}

module.exports = Scratch3VideoSensingBlocks;
